import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import HyvidStore from "./index";
import { ShoppingBag } from "lucide-react";
import { MODULE_HYVIDSTORE } from "variables/modules";


const storeRoutes = [	
    generateCRUDRoutes({
        mainTitle: "HyVid Store",
        basePath: "hyvid-store",
        mainComponent: <HyvidStore />,
        layout: "/console",	   
        icon: <ShoppingBag className="icon-item" />,
        subTitle:"HyVid Store",
        level:5,
        moduleId: MODULE_HYVIDSTORE,
    })
]

export default storeRoutes;